import { render } from "./AmazingFeatures.vue?vue&type=template&id=955fc198"
import script from "./AmazingFeatures.vue?vue&type=script&lang=js"
export * from "./AmazingFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__